module.exports = __webpack_public_path__ + "static/media/MultiPlot.a197fb73.logo";